import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { trackEvent } from '@/utils/trackingClient';

/**
 * /formular -> form_open Event + Redirect zur Startseite mit
 * Hash, damit die Formular-Sektion in den Viewport scrollt.
 */
const FormRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let redirected = false;
    const target = `/${location.search}#anfrage`;
    const doRedirect = () => {
      if (redirected) return;
      redirected = true;
      navigate(target, { replace: true });
      // Manueller Scroll-Trigger nach Render
      setTimeout(() => {
        const el = document.getElementById('anfrage') || document.getElementById('lead-form');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    };

    trackEvent('form_open', {
      event_type: 'click',
      destination_url: target,
      timeoutMs: 500,
    }).finally(doRedirect);

    const safety = setTimeout(doRedirect, 800);
    return () => clearTimeout(safety);
  }, [navigate, location.search]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FBF9F5]">
      <Loader2 className="w-7 h-7 animate-spin text-[#4A331D]" />
      <span className="ml-3 text-sm text-gray-600" data-testid="form-redirect">Formular wird geladen…</span>
    </div>
  );
};

export default FormRedirect;
